import { z } from 'zod';

export const workflowBasicsSchema = z.object({
  name: z.string().min(1, 'Name erforderlich'),
  description: z.string().optional(),
});

export const workflowChannelSchema = z.object({
  channel: z.enum(['linkedin', 'email', 'blog', 'custom']).default('custom'),
});

export const workflowStepSchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'Name erforderlich'),
  provider: z.enum(['openai', 'claude', 'perplexity']).default('openai'),
  prompt: z.string().min(1, 'Prompt erforderlich'),
  systemPrompt: z.string().optional(),
});

export const workflowStepsSchema = z.object({
  steps: z.array(workflowStepSchema).min(1, 'Mindestens ein Schritt'),
});

export const workflowReviewSchema = z.object({});

export const workflowBuilderSchema = workflowBasicsSchema
  .merge(workflowChannelSchema)
  .merge(workflowStepsSchema);

export type WorkflowBuilderValues = z.infer<typeof workflowBuilderSchema>;

export const workflowBuilderDefaults: WorkflowBuilderValues = {
  name: '',
  description: '',
  channel: 'custom',
  steps: [],
};

export const channelTemplates: Record<string, { name: string; provider: 'openai' | 'claude' | 'perplexity'; prompt: string }[]> = {
  linkedin: [
    { name: 'Beitragsidee', provider: 'openai', prompt: 'Erstelle eine LinkedIn-Beitragsidee zum Thema: {{thema}}' },
    { name: 'Ausformulierung', provider: 'claude', prompt: 'Formuliere die Beitragsidee als LinkedIn-Post mit Hook, Körper und Call-to-Action aus.' },
  ],
  email: [
    { name: 'Betreffzeile', provider: 'openai', prompt: 'Schreibe 3 Betreffzeilen-Varianten für: {{thema}}' },
    { name: 'Body', provider: 'claude', prompt: 'Schreibe eine kurze E-Mail (max. 120 Wörter) zu: {{thema}}' },
  ],
  blog: [
    { name: 'Gliederung', provider: 'perplexity', prompt: 'Erstelle eine Gliederung mit 5 Abschnitten für einen Blog-Artikel über: {{thema}}' },
    { name: 'Artikel', provider: 'claude', prompt: 'Schreibe den vollständigen Blog-Artikel basierend auf der Gliederung.' },
  ],
  custom: [],
};
